module.exports = __webpack_public_path__ + "img/folder.c5b69ace.svg";